// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main[data-v-729def56] {\n  width: 100%;\n  min-height: calc(100vh - 200px);\n}", ""]);
// Exports
module.exports = exports;
